import styled from 'styled-components'
import {
	media,
	Breakpoints,
	WrapperColor,
	textModels,
	themeObject,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperColor)`
	${media('padding: 88px 148px;', Breakpoints.lx)}
`
export const TitleModel = styled.p`
	${textModels('heading', 'h2')}
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 8px;
`
export const SubTitleModel = styled.p`
	${textModels('text', 'l', '400')}
	color: ${themeObject.colors.grey[600]};
	margin-bottom: 32px;
`
